import React, { useState } from 'react';
import "../../styles/convocation/main.css";
import { Container, Button, Modal, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Main = () => {
    const [showEvent1, setShowEvent1] = useState(false);
    const [showEvent2, setShowEvent2] = useState(false);
    const [showEvent3, setShowEvent3] = useState(false);
    const [showEvent4, setShowEvent4] = useState(false);

    return (
        <Container className="mt-5 mb-5">
            <h1 className="text-center mb-4 my-heading">
                CCSU Meerut University 38th Convocation
            </h1>

            {/* Cards */}
            <div className="convocation-main">
                <div className="row">
                    <div className="col-md-3">
                        <div className="card-convocation">
                            <div className="card-body">
                                <h5 className="card-title-convocation">Medal & Certificate List</h5>
                                <Link to={"#"} className="stretched-link" data-toggle="modal" onClick={() => setShowEvent1(true)}>
                                    <span className="sr-only">Open Medal & Certificate List Modal</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card-convocation">
                            <div className="card-body">
                                <h5 className="card-title-convocation">University Campus Courses Merit List</h5>
                                <Link to={"#"} className="stretched-link" data-toggle="modal" onClick={() => setShowEvent2(true)}>
                                    <span className="sr-only">Open University Campus Courses Merit List Modal</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card-convocation">
                            <div className="card-body">
                                <h5 className="card-title-convocation">Professional Courses Merit List</h5>
                                <Link to={"#"} className="stretched-link" data-toggle="modal" onClick={() => setShowEvent3(true)}>
                                    <span className="sr-only">Open Professional Courses Merit List Modal</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card-convocation">
                            <div className="card-body">
                                <h5 className="card-title-convocation">Confidential Merit List</h5>
                                <Link to={"#"} className="stretched-link" data-toggle="modal" onClick={() => setShowEvent4(true)}>
                                    <span className="sr-only">Open Confidential Merit List Modal</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modals */}
            {/* Event 1 Modal */}
            <Modal show={showEvent1} onHide={() => setShowEvent1(false)} size="lg" className='modalMain'>
                <Modal.Header closeButton>
                    <Modal.Title>Medal &amp; Certificate List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table bordered className='table'>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Title</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>38th Convocation 2026 Performa</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/Performa.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>38th Convocation 2026 Press Release</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/Letter_repaired%20%20A.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Chancellor Gold Medal - 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/Chancellor%20Gold%20Medal%202026_repaired%20(1)%20A.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Former President Dr. Shankar Dayal Sharma Gold Medal - 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/Dr.%20Shankar%20Dayal%20Sharma%20Gold%20Medal%202026_repaired%20(1)%20A.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>Chaudhary Charan Singh Smriti Pratibha Puraskar - 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/Kishan%20Trust%202026_repaired%20(1)%20A.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>Sponcored Gold Medal List - 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/Sporncored%20Medal%202026%20A.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>Vice Chancellor Gold Medal & Merit Certificate List - 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/VC%20Medal%202026_repaired%20A.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>Vice Chancellor Gold Medal & Merit Certificate List - 2025</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/VC%20Medal%202025_repaired%20(1)%20A.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>1</td>
                                <td>Convocation 2024 Press Release</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/Convocation%202024%20Press%20Release%20.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Convocation Press Release </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/press%20release%20(5).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Convocation Notification</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/Convocation%202024%20Notification.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Convocation Parforma 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/Convocation%20Parforma%202024.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>
                                    Letter
                                </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/01.%20Letter%20(1).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>Chancellor's Gold Medal List 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/02.%20Chancellor's%20Gold%20Medal_List_2024%20(1).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>DSDS Gold Medal List 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/03.%20DSDS%20Gold%20Medal_List_2024%20(1).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>Kisan Trust Award List 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/04.%20Kisan%20Trust%20Award_List_2024%20(1).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>

                            <tr>
                                <td>9</td>
                                <td>Sponcored Gold Medal List 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/05.%20Sponcored%20Gold_Medal_List_2024.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>
                                    Vice Chancellor Medal 2024
                                </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/06.%20Vice%20Chancellor%20Medal%202024%20(1).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>
                                    Merit List 2024
                                </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/07.%20Merit%20List%202024%20(1).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>Vice Chancellor Medal 2023</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/08.%20Vice%20Chancellor%20Medal%202023%20(1).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>Vice Chancellor Medal 2022</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/09.%20Vice%20Chancellor%20Medal%202022.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr> */}
                            {/* <tr>
                                <td></td>
                                <td>37th Convocation Notification</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/Convocation%20Notification%202025.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>https://convocationmedal.ccsuniversity.ac.in/</td>
                                <td>
                                    <a href="https://convocationmedal.ccsuniversity.ac.in/"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Convocation 2025 Press Release</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/01.%20Letter%20(2).pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>37th Convocation 2025 Perfoma</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/02.%20Performa%202025.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr> */}
                            {/* <tr>
                                <td>3</td>
                                <td>FORMER PRESIDENT DR. SHANKAR DAYAL SHARMA GOLD MEDAL – 2025</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/03.%20Ex-President,%20Dr.%20Shankar%20Dayal%20Sharma%20Gold%20Medal%202025.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr> */}
                            {/* <tr>
                                <td>3</td>
                                <td>CHANCELLOR GOLD MEDAL – 2025</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/03.%20Chancellor%20Gold%20Medal%202025.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>FORMER PRESIDENT DR. SHANKAR DAYAL SHARMA GOLD MEDAL – 2025</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/04.%20Dr.%20Shankar%20Dayal%20Sharma%20Gold%20Medal%202025.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>CHAUDHARY CHARAN SINGH SMRITI PRATIBHA PURASKAR – 2025</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/05.%20Chaudhary%20Charan%20Singh%20Smriti%20Prathibha%20Puraskar%202025.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>Sponcored Gold Medal 2025</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/06.%20Sponcored%20Gold%20Medal%202025.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>Vice Chancellor Gold Medal 2025</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/07.%20Vice%20Chancellor%20Gold%20Medal%202025.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>MERIT CERTIFICATE LIST – 2025</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/08.%20Merit%20Certificate%202025.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>9</td>
                                <td>VICE-CHANCELLOR GOLD MEDAL & MERIT CERTIFICATE LIST – 2024</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/09.%20Vice%20Chancellor%20Gold%20Medal%202024.pdf"
                                        className="btn btn-download btn-primary"
                                        rel='noreferrer'
                                        target="_blank">Download
                                    </a>
                                </td>
                            </tr> */}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEvent1(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Event 2 Modal */}
            <Modal show={showEvent2} onHide={() => setShowEvent2(false)} size="lg" className='modalMain'>
                <Modal.Header closeButton>
                    <Modal.Title>University Campus Courses Merit List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table bordered className='table'>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Updated Date</th>
                                <th>Title</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>01</td>
                            <td>10-06-2026</td>
                            <td>M.Sc. HORTICULTURE year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/01c.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>02</td>
                            <td>10-06-2026</td>
                            <td>M.SC. POLYMER SCIENCE year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/02c.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>03</td>
                            <td>10-06-2026</td>
                            <td>M.A. JYOTRIVIGYAN year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/03c.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>04</td>
                            <td>10-06-2026</td>
                            <td>M.Sc. Ag. PATHOLOGY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/04c.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>05</td>
                            <td>10-06-2026</td>
                            <td>M.Sc. Ag. ENTOMOLOGY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/05c.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>06</td>
                            <td>10-06-2026</td>
                            <td>B.Sc. FOOD MICROBIOLOGY SAFETY & QUALITY CONTROL year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/06c.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>07</td>
                            <td>11-06-2026</td>
                            <td>M.Sc. APPLIED MICROBIOLOGY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/07c.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        {/* <tr>
                            <td>08</td>
                            <td>11-06-2026</td>
                            <td>M.A. YOGIC SCIENCE year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/08c.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr> */}
                        <tr>
                            <td>08</td>
                            <td>11-06-2026</td>
                            <td>B.A.J.M.C. (HONORS) year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/09c.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>09</td>
                            <td>15-06-2026</td>
                            <td>M.Sc.FOOD SCIENCE AND TECHNOLOGY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/10.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        {/* <tr>
                            <td>10</td>
                            <td>16-06-2026</td>
                            <td>BA/B.Sc. YOGIC SCIENCE year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/010%20(85)%20(1).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr> */}
                        <tr>
                            <td>10</td>
                            <td>16-06-2026</td>
                            <td>M.Sc. Ag SEED SCIENCE year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/011%20(54).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        {/* <tr>
                            <td>12</td>
                            <td>16-06-2026</td>
                            <td>M.A/M.Sc. YOGIC SCIENCE year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/012%20(63).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr> */}
                        <tr>
                            <td>11</td>
                            <td>22-06-2026</td>
                            <td>M.A. SOCIAL WORK year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/001%20(31).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>12</td>
                            <td>22-06-2026</td>
                            <td>M.Sc. TOXICOLOGY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/002%20(17).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>13</td>
                            <td>22-06-2026</td>
                            <td>M.Sc. BIO INFORMATICS year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/003%20(8).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>14</td>
                            <td>22-06-2026</td>
                            <td>M.Sc. Ag. GENETICS AND PLANT BREEDING year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/004%20(1).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>15</td>
                            <td>22-06-2026</td>
                            <td>B.A. (HONS.) HISTORY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/005%20(1).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>16</td>
                            <td>22-06-2026</td>
                            <td>BA. (HONS.) ECONOMICS year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/006%20(1).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>17</td>
                            <td>24-06-2026</td>
                            <td>M.COM CAMPUS year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/001%20-%202026-06-24T132335.167.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>18</td>
                            <td>24-06-2026</td>
                            <td>M.A. GEOGRAPHY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/002%20-%202026-06-24T132428.772.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>19</td>
                            <td>24-06-2026</td>
                            <td>M.Sc. FORENSIC SCIENCE year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/003%20(84)%20(1).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>20</td>
                            <td>24-06-2026</td>
                            <td>BA. (HONS.) ENGLISH year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/005%20(55).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>21</td>
                            <td>24-06-2026</td>
                            <td>M.Sc. STATISTICS year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/006%20(43)%20(1).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>22</td>
                            <td>24-06-2026</td>
                            <td>MA. HISTORY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/007%20(31).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>23</td>
                            <td>24-06-2026</td>
                            <td>M.Sc. ENVIRONMENTAL SCIENCE year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/008%20(29)%20(1).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        {/* <tr>
                            <td>26</td>
                            <td>24-06-2026</td>
                            <td>B.F.A. year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/009%20(15)%20(1).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr> */}
                        {/* <tr>
                            <td>27</td>
                            <td>24-06-2026</td>
                            <td>B.P.E.S. year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/010%20(13)%20(1).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr> */}
                        <tr>
                            <td>24</td>
                            <td>24-06-2026</td>
                            <td>M.Sc. BIO CHEMISTRY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/011%20(12)%20(1).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        {/* <tr>
                            <td>27</td>
                            <td>24-06-2026</td>
                            <td>BA/B.Sc. (HONS.) GEOGRAPHY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/027%20(1).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr> */}
                        <tr>
                            <td>25</td>
                            <td>29-06-2026</td>
                            <td>B.Sc. CHEMISTRY (HONS) year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/campus%20001.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        {/* <tr>
                            <td>29</td>
                            <td>29-06-2026</td>
                            <td>B.SC. BIOTECHNOLOGY CAMPUS year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/013%20(7).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr> */}
                        <tr>
                            <td>26</td>
                            <td>29-06-2026</td>
                            <td>MFA DRAWING & PAINTING year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/014%20(5).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>27</td>
                            <td>29-06-2026</td>
                            <td>MASTER OF LIBRARY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/015%20(4)%20prof.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>28</td>
                            <td>02-07-2026</td>
                            <td>B.Sc. YOGIC SCIENCE year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/campus002.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>29</td>
                            <td>02-07-2026</td>
                            <td>B.A. YOGIC SCIENCE year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/campus003.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>30</td>
                            <td>02-07-2026</td>
                            <td>M.Sc. MATHEMATICS year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/campus004.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>31</td>
                            <td>02-07-2026</td>
                            <td>BA. (HONS.) GEOGRAPHY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/campus005.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>32</td>
                            <td>02-07-2026</td>
                            <td>B.Sc. (HONS.) GEOGRAPHY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/campus006.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>33</td>
                            <td>02-07-2026</td>
                            <td>M.Sc. YOGIC SCIENCE year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/campus007.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>34</td>
                            <td>02-07-2026</td>
                            <td>M.A. YOGIC SCIENCE year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/campus008.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>35</td>
                            <td>02-07-2026</td>
                            <td>B.B.A.H.A. year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/campus009.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>36</td>
                            <td>02-07-2026</td>
                            <td>B.LIB year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/campus010.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>37</td>
                            <td>03-07-2026</td>
                            <td>B.Sc. HOME SCIENCE year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/campus008%20(30).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>38</td>
                            <td>03-07-2026</td>
                            <td>M.Ed. year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/campus009%20(16).pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>39</td>
                            <td>04-07-2026</td>
                            <td>M.Sc. BIO-TECHNOLOGY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/005%20(55)%20camp.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>40</td>
                            <td>08-07-2026</td>
                            <td>M.A. POLITICAL SCIENCE year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/Adobe%20Scan%2008%20Jul%202026%20(1)_repaired.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr>
                        <tr>
                                <td>41</td>
                                <td>16-07-2026</td>
                                <td>B.Sc. BIOTECHNOLOGY Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/001%20-%202026-07-16T143251.912.pdf">Download
                                    </a>
                                </td>
                            </tr>
                        {/* <tr>
                            <td>19</td>
                            <td>22-06-2026</td>
                            <td>B.Sc. (HONS.) GEOGRAPHY year 2026</td>
                            <td>
                                <a className="btn btn-primary btn-download" rel='noreferrer'
                                    href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/007.pdf"
                                    target="_blank">Download</a>
                            </td>
                        </tr> */}
                        
                            {/* <tr>
    <td>01</td>
    <td>01-08-2025</td>
    <td>M.A.J.M.C year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/001%20(77).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>02</td>
    <td>01-08-2025</td>
    <td>M.F.A. Applied Arts year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/002%20(76).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>03</td>
    <td>01-08-2025</td>
    <td>M.F.A. Drawing and Painting year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/003%20(57).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>04</td>
    <td>01-08-2025</td>
    <td>B.A.J.M.C Honours year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/004%20(39).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>05</td>
    <td>01-08-2025</td>
    <td>M.A. Hindi year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/005%20(36).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>06</td>
    <td>01-08-2025</td>
    <td>M.A. Sanskrit year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/006%20(28).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>07</td>
    <td>01-08-2025</td>
    <td>M.A. Urdu year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/007%20(17).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>08</td>
    <td>01-08-2025</td>
    <td>M.A. English year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/008%20(17).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>09</td>
    <td>01-08-2025</td>
    <td>M.A. History year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/009%20(6).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>10</td>
    <td>01-08-2025</td>
    <td>M.A. Political Science year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/010%20(8).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>11</td>
    <td>01-08-2025</td>
    <td>M.A. Sociology year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/011%20(6).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>12</td>
    <td>01-08-2025</td>
    <td>M.A. Economics year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/012%20(6).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>13</td>
    <td>01-08-2025</td>
    <td>M.A. Psychology year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/013%20(3).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>14</td>
    <td>01-08-2025</td>
    <td>M.A. Geography year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/014%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>15</td>
    <td>01-08-2025</td>
    <td>M.A. Social Work year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/015%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>16</td>
    <td>21-08-2025</td>
    <td>Revised M.P.A. year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/011%20(9).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>17</td>
    <td>01-08-2025</td>
    <td>M.A. Ancient History year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/017%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>18</td>
    <td>01-08-2025</td>
    <td>M.Sc. Physics year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/018%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>19</td>
    <td>01-08-2025</td>
    <td>M.Sc. Chemistry year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/019.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>20</td>
    <td>21-08-2025</td>
    <td>Revised M.Sc. Mathematics year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/010%20(11).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>21</td>
    <td>01-08-2025</td>
    <td>M.Sc. Botany year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/021.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>22</td>
    <td>01-08-2025</td>
    <td>M.Sc. Zoology year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/022%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>23</td>
    <td>01-08-2025</td>
    <td>M.Sc. Statistic year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/023%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>24</td>
    <td>01-08-2025</td>
    <td>M.Sc. Geography year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/024.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>25</td>
    <td>01-08-2025</td>
    <td>M.Sc. Toxicology year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/025.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>26</td>
    <td>01-08-2025</td>
    <td>M.Sc. Microbiology year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/026.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>27</td>
    <td>07-08-2025</td>
    <td>L.L.M year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/001%20(16).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>28</td>
    <td>07-08-2025</td>
    <td>M.Sc.Yogic Science year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/002%20(4).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>29</td>
    <td>07-08-2025</td>
    <td>M.Sc. Medical Microbiology year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/003%20(4).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>30</td>
    <td>08-09-2025</td>
    <td>Revised B.Sc. Food Microbiology Safty & Quality Control</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/002%20(87).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>31</td>
    <td>07-08-2025</td>
    <td>B.A. Hons. English year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/005%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>32</td>
    <td>07-08-2025</td>
    <td>B.A. Hons. Geography year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/006%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>33</td>
    <td>07-08-2025</td>
    <td>B.Com. Hons. Campus year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/007.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>34</td>
    <td>07-08-2025</td>
    <td>B.Sc. Hons. Geography year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/008.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>35</td>
    <td>10-09-2025</td>
    <td>Revised B.A. Hons. History year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/001%20(93).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>36</td>
    <td>07-08-2025</td>
    <td>B.A. Hons. Economics year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/010%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>37</td>
    <td>07-08-2025</td>
    <td>M.Com. year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/011%20(2).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>38</td>
    <td>07-08-2025</td>
    <td>M.Sc. Ag. Horticulture year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/012%20(2).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>39</td>
    <td>07-08-2025</td>
    <td>M.Sc. Biotechnology year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/013.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>40</td>
    <td>07-08-2025</td>
    <td>M.Sc. Ag. Genetics & Plant Breeding year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/014%20(2).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>41</td>
    <td>07-08-2025</td>
    <td>M.Sc. Ag. Entomology year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/015.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>42</td>
    <td>07-08-2025</td>
    <td>M.Sc. Ag. Pathology year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/016.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>43</td>
    <td>07-08-2025</td>
    <td>B.B.A.H.A. year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/017.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>44</td>
    <td>07-08-2025</td>
    <td>M.Sc. Polymer Science year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/018.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>45</td>
    <td>07-08-2025</td>
    <td>M.Sc. Ag. Seed Science & Technology year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/019%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>46</td>
    <td>07-08-2025</td>
    <td>P.G.D.D.M. year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/020%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>47</td>
    <td>07-08-2025</td>
    <td>M.Sc. Applied Microbiology year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/021%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>48</td>
    <td>07-08-2025</td>
    <td>B.Sc. Hons. Chemistry Campus year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/022.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>49</td>
    <td>07-08-2025</td>
    <td>M.A. Yogic Science year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/023.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>50</td>
    <td>07-08-2025</td>
    <td>P.G. Diploma in Vedic Mathematics year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/024%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>51</td>
    <td>08-09-2025</td>
    <td>Revised M.A. in Jyotirivigyan year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/001%20(92).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>52</td>
    <td>07-08-2025</td>
    <td>P.G. Diploma in Karmkand year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/026%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>53</td>
    <td>07-08-2025</td>
    <td>B.Lib Campus year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/027.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>54</td>
    <td>07-08-2025</td>
    <td>M.P.Ed Campus year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/028%20(1).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>55</td>
    <td>07-08-2025</td>
    <td>P.G. Diploma in Remote Sensing year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/029.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>56</td>
    <td>07-08-2025</td>
    <td>P.G. Diploma in Yoga year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/030.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>57</td>
    <td>07-08-2025</td>
    <td>M.Sc. Bio Informatics year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/031.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>58</td>
    <td>12-08-2025</td>
    <td>Master of Library year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/028_1.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>59</td>
    <td>12-08-2025</td>
    <td>M.Sc. Bio Chemistry year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/029_1.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>60</td>
    <td>12-08-2025</td>
    <td>PG Diploma in Guidence & Counciling year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/030_1.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>61</td>
    <td>12-08-2025</td>
    <td>Bachelor in Cinematography year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/031_1.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>62</td>
    <td>12-08-2025</td>
    <td>Bachelor in Film Theater year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/032.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>63</td>
    <td>12-08-2025</td>
    <td>B.A. Yogic Science year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/033.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>64</td>
    <td>12-08-2025</td>
    <td>B.Sc. Yogic Science year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/034.pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>65</td>
    <td>21-08-2025</td>
    <td>B.B.A. Campus year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/001%20(83).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>66</td>
    <td>21-08-2025</td>
    <td>Advance Diploma in French year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/002%20(80).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>67</td>
    <td>21-08-2025</td>
    <td>COP in French year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/003%20(61).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>68</td>
    <td>21-08-2025</td>
    <td>COP in Russia year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/004%20(44).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>69</td>
    <td>21-08-2025</td>
    <td>Diploma in Russia year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/005%20(41).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>70</td>
    <td>21-08-2025</td>
    <td>Diploma in French year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/006%20(33).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>71</td>
    <td>21-08-2025</td>
    <td>M.Sc. Ag. Food Sc. & Tech. year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/007%20(22).pdf"
            target="_blank">Download</a>
    </td>
</tr>                         
<tr>
    <td>72</td>
    <td>21-08-2025</td>
    <td>M.Ed. Campus year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/008%20(23).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>73</td>
    <td>21-08-2025</td>
    <td>B.P.Ed. Campus year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/009%20(10).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>74</td>
    <td>25-08-2025</td>
    <td>M.Sc. Environment Science year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/001%20(85).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>75</td>
    <td>25-08-2025</td>
    <td>P.G. Diploma in Geo-Informatics year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/002%20(81).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>76</td>
    <td>25-08-2025</td>
    <td>B.Sc. Biotechnology Campus year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/003%20(62).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>77</td>
    <td>01-09-2025</td>
    <td>B.Sc. NEP Campus year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/campus_list/005%20(44).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>78</td>
    <td>01-09-2025</td>
    <td>M.Sc. Home Science Food & Nutr (Campus) year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/campus_list/006%20(36).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>79</td>
    <td>04-09-2025</td>
    <td>B.A. NEP (Campus) year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/004%20(48).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>80</td>
    <td>04-09-2025</td>
    <td>M.A. Home Science (Campus) year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/campus_list/002%20(85).pdf"
            target="_blank">Download</a>
    </td>
</tr>
<tr>
    <td>81</td>
    <td>04-09-2025</td>
    <td>B.P.E.S. (Campus) year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/campus_list/003%20(66).pdf"
            target="_blank">Download</a>
    </td>
</tr> */}
{/* <tr>
    <td>77</td>
    <td>25-08-2025</td>
    <td>M.Sc. Ag. Pathology year 2025</td>
    <td>
        <a className="btn btn-primary btn-download" rel='noreferrer'
            href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/campus_merit_list/004%20(45).pdf"
            target="_blank">Download</a>
    </td>
</tr> */}
                        
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEvent2(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Event 3 Modal */}
            <Modal show={showEvent3} onHide={() => setShowEvent3(false)} size="lg" className='modalMain'>
                <Modal.Header closeButton>
                    <Modal.Title>Professional Courses Merit List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Updated Date</th>
                                <th>Title</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* <tr>
                                <td>01</td>
                                <td>08-06-2026</td>
                                <td>MD IN ANAESTHESIOLOGY Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/001%20-%202026-06-08T101135.464.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>02</td>
                                <td>08-06-2026</td>
                                <td>M.B.B.S. 3-1 Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/002%20-%202026-06-08T101200.014.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>03</td>
                                <td>08-06-2026</td>
                                <td>M.B.B.S.-2 Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/003%20(81).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>04</td>
                                <td>08-06-2026</td>
                                <td>M.B.B.S.-1 Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/004%20(61).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>05</td>
                                <td>08-06-2026</td>
                                <td>MS IN SURGERY Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/005%20(53)%20(1).pdf">Download
                                    </a>
                                </td>
                            </tr> */}
                            <tr>
                                <td>01</td>
                                <td>08-06-2026</td>
                                <td>B.U.M.S. IV Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/006%20(42).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>07</td>
                                <td>08-06-2026</td>
                                <td>MS IN ORTHOPAEDICS Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/007%20(30).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>08</td>
                                <td>08-06-2026</td>
                                <td>MS IN OPTHALMOLOGY Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/008%20(29).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>09</td>
                                <td>08-06-2026</td>
                                <td>MS IN OBST. & GYNAE. Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/009%20(15).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>08-06-2026</td>
                                <td>MD IN SKIN & V.D. Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/010%20(13).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>08-06-2026</td>
                                <td>MD IN PHYSIOLOGY Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/011%20(12).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>08-06-2026</td>
                                <td>MD IN PHARMACOLOGY Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/012%20(10)%20(2).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>08-06-2026</td>
                                <td>MD IN PATHOLOGY Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/013%20(7)%20(2).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>08-06-2026</td>
                                <td>MD IN PAEDIATRICS Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/014%20(5)%20(1).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>08-06-2026</td>
                                <td>MD IN OBST. & GYNAE. Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/015%20(4).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>08-06-2026</td>
                                <td>MD IN MEDICINE Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/016%20(3).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>17</td>
                                <td>08-06-2026</td>
                                <td>MD IN COMMUNITY MEDICINE Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/017%20(3).pdf">Download
                                    </a>
                                </td>
                            </tr> */}
                            <tr>
                                <td>02</td>
                                <td>08-06-2026</td>
                                <td>M.B.B.S. 3-2 Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/018%20(2).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>03</td>
                                <td>08-06-2026</td>
                                <td>B.A.M.S. IV Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/019%20(2).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>04</td>
                                <td>08-06-2026</td>
                                <td>B.TECH MECHANICAL ENGG. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/20%20(1).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>05</td>
                                <td>08-06-2026</td>
                                <td>M.C.A. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/21.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>06</td>
                                <td>08-06-2026</td>
                                <td>B.TECH CHEMICAL ENGG. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/22%20(1).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>07</td>
                                <td>08-06-2026</td>
                                <td>B.TECH AGRICULTURE ENGG. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/23.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>08</td>
                                <td>08-06-2026</td>
                                <td>B.TECH ELECTRONIC & COMMU. ENGG. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/24.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>09</td>
                                <td>08-06-2026</td>
                                <td>B.TECH COMPUTER SCIENCE ENGG. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/25.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>10</td>
                                <td>08-06-2026</td>
                                <td>B.TECH INFORMATION TECH. ENGG. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/26.pdf">Download
                                    </a>
                                </td>
                            </tr> */}
                            <tr>
                                <td>10</td>
                                <td>09-06-2026</td>
                                <td>M.TECH IN COMPUTER SCIENCE Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/001%20-%202026-06-09T130118.240_compressed.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>09-06-2026</td>
                                <td>M.TECH IN ELECTRONICS & COMMU. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/002%20-%202026-06-09T130111.959_compressed.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>11-06-2026</td>
                                <td>B.VOC. IN MEDICAL LAB TECHNOLOGY Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/29p.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>11-06-2026</td>
                                <td>B.Sc. COMPUTER SCIENCE Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/30p.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>11-06-2026</td>
                                <td>B.VOC. IN TOUR AND TRAVEL MANAGEMENT Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/31p.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>32</td>
                                <td>15-06-2026</td>
                                <td>MD IN PAEDIATRICS Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/32p.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>33</td>
                                <td>15-06-2026</td>
                                <td>DM IN ENDOCRINOLOGY Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/33p.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>34</td>
                                <td>15-06-2026</td>
                                <td>DM IN MCH Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/34p.pdf">Download
                                    </a>
                                </td>
                            </tr> */}
                            <tr>
                                <td>15</td>
                                <td>16-06-2026</td>
                                <td>B.Sc. MICROBIOLOGY Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/002%20-%202026-06-16T.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>16</td>
                                <td>17-06-2026</td>
                                <td>B.Sc. BIOTECHNOLOGY Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/005%20(54)_compressed%20(1).pdf">Download
                                    </a>
                                </td>
                            </tr> */}
                            {/* <tr>
                                <td>37</td>
                                <td>24-06-2026</td>
                                <td>B.P.E.S. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/012%20(10)%20(3).pdf">Download
                                    </a>
                                </td>
                            </tr> */}
                            <tr>
                                <td>16</td>
                                <td>24-06-2026</td>
                                <td>M.B.A.H.A. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/013%20(7)%20(3).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>39</td>
                                <td>24-06-2026</td>
                                <td>B.F.A. COMBINED Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/014%20(5)%20(2).pdf">Download
                                    </a>
                                </td>
                            </tr> */}
                            <tr>
                                <td>17</td>
                                <td>24-06-2026</td>
                                <td>M.Sc. HOME SCIENCE (CLOTHING & TEXTILE) Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/015%20(4)%20(1).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>18</td>
                                <td>24-06-2026</td>
                                <td>M.Sc. BIOTECHNOLOGY Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/016%20(3)%20(1).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>19</td>
                                <td>24-06-2026</td>
                                <td>M.Sc. MICROBIOLOGY Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/017%20(3)%20(1).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>20</td>
                                <td>25-06-2026</td>
                                <td>M.B.A. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/009%20prof%20(15).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>21</td>
                                <td>25-06-2026</td>
                                <td> B.Sc. COMPUTER SCIENCE (HONS) Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/009%20prof%20(16).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>22</td>
                                <td>29-06-2026</td>
                                <td>B.B.A. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/001%20prof.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>23</td>
                                <td>29-06-2026</td>
                                <td>B.C.A. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/002prof.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>24</td>
                                <td>29-06-2026</td>
                                <td>B.Com. (HONS) Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/003%20prof.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>25</td>
                                <td>29-06-2026</td>
                                <td>M.Sc. COMPUTER SCIENCE Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/004%20prof.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>49</td>
                                <td>29-06-2026</td>
                                <td>MASTER OF LIBRARY Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/005%20prof.pdf">Download
                                    </a>
                                </td>
                            </tr> */}
                            <tr>
                                <td>26</td>
                                <td>29-06-2026</td>
                                <td>M.I.B Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/006%20prof.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>27</td>
                                <td>29-06-2026</td>
                                <td>M.A. JOURNALISM & MASS COMMUNICATION Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/007%20prof.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>49</td>
                                <td>29-06-2026</td>
                                <td>MP.Ed. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/008%20prof.pdf">Download
                                    </a>
                                </td>
                            </tr> */}
                            <tr>
                                <td>28</td>
                                <td>03-07-2026</td>
                                <td>BA. JOURNALISM & MASS COMM. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/001%20-%202026-07-03T125532.637.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>29</td>
                                <td>16-07-2026</td>
                                <td>M.Sc. HSc (FOOD & NUTRITION) Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/001%20-%202026-07-18T144728.057.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>30</td>
                                <td>03-07-2026</td>
                                <td> DM IN ENDOCRINOLOGY/ DM IN MCH Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/010%20(13)_repaired.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>31</td>
                                <td>03-07-2026</td>
                                <td>M.Sc. HSC (HUMAN DEVELOPMENT) Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/011%20(13)_repaired.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>32</td>
                                <td>03-07-2026</td>
                                <td>B.Sc. HOME SCIENCE (CLIN. & DIT.) Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/012%20(11)_repaired.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>33</td>
                                <td>03-07-2026</td>
                                <td>M.D/M.S. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/013%20(8)_repaired.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>34</td>
                                <td>04-07-2026</td>
                                <td>B.P.Ed. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/Adobe%20Scan%2004%20Jul%202026-1.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>35</td>
                                <td>04-07-2026</td>
                                <td>B.F.A. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/Adobe%20Scan%2004%20Jul%202026-2.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>36</td>
                                <td>04-07-2026</td>
                                <td>B.P.E.S. Regular Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/Adobe%20Scan%2004%20Jul%202026-3.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>37</td>
                                <td>04-07-2026</td>
                                <td>M.P.Ed Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/004%20(65)%20prf.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>38</td>
                                <td>11-06-2026</td>
                                <td>B.TECH INFORMATION TECH. ENGG. Course 2026</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/shared%20image%20(36).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>01</td>
                                <td>28-07-2025</td>
                                <td>B.VOC (ACP) Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/professionaldeptmeritlist/001%20(16).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>02</td>
                                <td>28-07-2025</td>
                                <td>M.A.J.M.C Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/professionaldeptmeritlist/002%20(4).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>03</td>
                                <td>28-07-2025</td>
                                <td>M.I.B Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/professionaldeptmeritlist/003%20(4).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>04</td>
                                <td>28-07-2025</td>
                                <td>B.VOC Yogic Science Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/professionaldeptmeritlist/004%20(1).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>05</td>
                                <td>28-07-2025</td>
                                <td>M.Sc. Computer Science Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/professionaldeptmeritlist/005%20(1).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>06</td>
                                <td>28-07-2025</td>
                                <td>Master of Library Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/professionaldeptmeritlist/006%20(1).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>07</td>
                                <td>28-07-2025</td>
                                <td>B.Sc. Computer Science Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/professionaldeptmeritlist/007.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>08</td>
                                <td>28-07-2025</td>
                                <td>B.Sc. Home Science (CLIN & DLT) Regular Course 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/professionaldeptmeritlist/008.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>09</td>
                                <td>28-07-2025</td>
                                <td>B.A. Journalism & Mass Communication Regular Course  2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/professionaldeptmeritlist/009.pdf">Download
                                    </a>
                                </td>
                            </tr>



                            <tr>
                                <td>10</td>
                                <td>03-08-2025</td>
                                <td>LLB Campus Regular Course year 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank" rel="noreferrer"
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/004%20(40).jpg">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>02-09-2025</td>
                                <td>Revised B.Tech Chemical Engg. Regular Course year 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank" rel="noreferrer"
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/Professional_dept/B.Tech%20(C.E.)%202025.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>03-08-2025</td>
                                <td>B.Tech Agriculture Engg. Regular Course year 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank" rel="noreferrer"
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/006%20(29).jpg">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>03-08-2025</td>
                                <td>B.Tech Information Tech. Engg. Regular Course year 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank" rel="noreferrer"
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/007%20(18).jpg">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>03-08-2025</td>
                                <td>B.Tech Electronics & Communication Engg. Course year 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank" rel="noreferrer"
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/008%20(18).jpg">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>11-08-2025</td>
                                <td>Revised M.P.Ed. Regular Course year 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank" rel="noreferrer"
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/023.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>03-08-2025</td>
                                <td>M.C.A. Regular Course year 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank" rel="noreferrer"
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/010%20(9).jpg">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>17</td>
                                <td>11-08-2025</td>
                                <td>Revised B.P.E.S Regular Course year 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank" rel="noreferrer"
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/026%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>18</td>
                                <td>03-08-2025</td>
                                <td>B.Tech Computer Science Engg. Regular Course year 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank" rel="noreferrer"
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/012%20(7).jpg">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>19</td>
                                <td>07-08-2025</td>
                                <td>Revised M.B.A. Regular Course year 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank" rel="noreferrer"
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/032.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>20</td>
                                <td>03-08-2025</td>
                                <td>B.Tech Mechanical Engg. Regular Course year 2025</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank" rel="noreferrer"
                                        href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/014%20(2).jpg">Download</a>
                                </td>
                            </tr>


                            <tr>
                                <td>21</td>
                                <td>05-08-2025</td>
                                <td>B.VOC. Medical Diagnosis & Lab Tech. Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/001%20(78)-1.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>22</td>
                                <td>05-08-2025</td>
                                <td>B.VOC. in Tour & Travel Management Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/002%20(77).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>23</td>
                                <td>05-08-2025</td>
                                <td>B.F.A. Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/005%20(58).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>24</td>
                                <td>05-08-2025</td>
                                <td>B.Com. (Hons.) Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/004%20(41).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>25</td>
                                <td>14-08-2025</td>
                                <td>Revised M.Tech. E.C. Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/005%20(39).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>26</td>
                                <td>05-08-2025</td>
                                <td>B.A.L.L.B. Campus Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/006%20(30).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>27</td>
                                <td>07-08-2025</td>
                                <td>B.D.S. Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/033.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>28</td>
                                <td>07-08-2025</td>
                                <td>BAMS Regular Course year 2024</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/034.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>29</td>
                                <td>07-08-2025</td>
                                <td>BUMS Regular Course year 2024</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/035%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>30</td>
                                <td>07-08-2025</td>
                                <td>D.M. in Endocrinology Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/036%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>31</td>
                                <td>07-08-2025</td>
                                <td>M.B.B.S. IIIrd Ist Prof. (Only L.L.R.M. Medical College) Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/037.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>32</td>
                                <td>07-08-2025</td>
                                <td>M.B.B.S. IInd Prof. (Only L.L.R.M. Medical College) Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/038.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>33</td>
                                <td>02-09-2025</td>
                                <td>Revised M.B.B.S. IIIrd Prof.-Part IInd (Only L.L.R.M. Medical College) Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/Professional_dept/MBBS%20III%20Prof.%20Part%20II%20(LLRM%20Medical%20College).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>34</td>
                                <td>07-08-2025</td>
                                <td>M.B.B.S. Ist Prof. (Only L.L.R.M. Medical College) Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/040.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>35</td>
                                <td>02-09-2025</td>
                                <td>Revised M.B.B.S. IIIrd Prof. Part IInd All Colleges Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/Professional_dept/MBBS%20III%20Prof.%20Part%20II%20(All%20Colleges).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>36</td>
                                <td>12-08-2025</td>
                                <td>M.S. in Ophthalmology Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/006%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>37</td>
                                <td>12-08-2025</td>
                                <td>M.S. in Surgery Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/007.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>38</td>
                                <td>12-08-2025</td>
                                <td>M.D. in Radiodiagnosis Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/008.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>39</td>
                                <td>12-08-2025</td>
                                <td>M.S. in OBST. & GYNAE. Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/009.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>40</td>
                                <td>12-08-2025</td>
                                <td>M.D. in Medicine Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/010%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>41</td>
                                <td>12-08-2025</td>
                                <td>M.D. in Anaesthesiology Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/011%20(2).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>42</td>
                                <td>12-08-2025</td>
                                <td>M.D. in Dermatology Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/012%20(2).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>43</td>
                                <td>12-08-2025</td>
                                <td>M.S. in Orthopedics Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/013.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>44</td>
                                <td>12-08-2025</td>
                                <td>M.D. in S.P.M. Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/014%20(2).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>45</td>
                                <td>12-08-2025</td>
                                <td>M.D. in Physiology Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/015.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>46</td>
                                <td>12-08-2025</td>
                                <td>M.D. in Pharmacology Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/016.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>47</td>
                                <td>12-08-2025</td>
                                <td>M.D. in Pathology Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/017.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>48</td>
                                <td>12-08-2025</td>
                                <td>M.D. in Paediatrics Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/018.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>49</td>
                                <td>12-08-2025</td>
                                <td>M.Sc. Bio Chemistry Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/019%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>50</td>
                                <td>12-08-2025</td>
                                <td>M.Sc. Microbiology Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/020%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>51</td>
                                <td>12-08-2025</td>
                                <td>M.Sc. Bio Informatics Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/021%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>52</td>
                                <td>12-08-2025</td>
                                <td>B.Sc. Computer Science Honours Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/022.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>53</td>
                                <td>12-08-2025</td>
                                <td>M.Sc. BioTechnology Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/024%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>54</td>
                                <td>12-08-2025</td>
                                <td>B.Sc. Microbiology Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/025%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>55</td>
                                <td>13-08-2025</td>
                                <td>B.C.A. Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/001%20(79).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>56</td>
                                <td>13-08-2025</td>
                                <td>B.Sc. Home Science Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/002%20(77)%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>57</td>
                                <td>15-09-2025</td>
                                <td>Revised B.Lib All Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/professional_merit_notice.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>58</td>
                                <td>19-08-2025</td>
                                <td>Revised B.Sc. Biotechnology Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/001%20(81).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>59</td>
                                <td>13-08-2025</td>
                                <td>M.B.A.H.A Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/005%20(38)%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>60</td>
                                <td>13-08-2025</td>
                                <td>B.Sc. Hons. Chemistry All Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/006%20(30)%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>61</td>
                                <td>14-08-2025</td>
                                <td>B.B.A. Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/001%20(80).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>62</td>
                                <td>14-08-2025</td>
                                <td>Diploma Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/002%20(78).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>63</td>
                                <td>14-08-2025</td>
                                <td>M.Tech CS Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/003%20(59).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>64</td>
                                <td>14-08-2025</td>
                                <td>M.P.E.S Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/004%20(42).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>65</td>
                                <td>19-08-2025</td>
                                <td>B.P.Ed. Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/002%20(79).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>66</td>
                                <td>02-09-2025</td>
                                <td>Revised M.Sc. Home Science (Human Development) Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/Professional_dept/M.Sc.%20Home%20Sci.%20Human%20Dev.%202025.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>67</td>
                                <td>19-08-2025</td>
                                <td>M.Sc. Home Science (Food & Nutr) Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/004%20(43).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>68</td>
                                <td>19-08-2025</td>
                                <td>M.Sc. Home Science Textile Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/005%20(40).pdf">Download</a>
                                </td>
                            </tr> */}
                            {/* <tr>
                                <td>68</td>
                                <td>19-08-2025</td>
                                <td>M.Sc. Home Science Textile Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_dept/005%20(40).pdf">Download</a>
                                </td>
                            </tr> */}
                            {/* <tr>
                                <td>27</td>
                                <td>06-08-2025</td>
                                <td>M.A. Physical Education Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_01.pdf">Download</a>
                                </td>
                            </tr> */}


                            {/* <tr>
                                <td>10</td>
                                <td>30-07-2024</td>
                                <td>B.Sc. Honours (Computer Science) Campus Regular Course year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/bsc_hon_cs.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>30-07-2024</td>
                                <td>B.A. (Journalism & Mass Communication) Regular Course year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ba_jms.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>30-07-2024</td>
                                <td>B.P.T. Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/bpt.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>30-07-2024</td>
                                <td>B.Sc. Home Science (CLI, NUT, DIT) Regular Course year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/bsc_hs_cli_dit_nut.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>30-07-2024</td>
                                <td>M.S. Ayurvedic in (Prasuti Tantra Evum Stree Rog) Regular Course
                                    year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/msc_aryuvedic.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>30-07-2024</td>
                                <td>M.C.A. Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/mca.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>30-07-2024</td>
                                <td>B.VOC (ACP) Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/bvoc_acp.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>17</td>
                                <td>30-07-2024</td>
                                <td>M.B.B.S. (Only L.L.R.M. Medical College) Regular Course year
                                    2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/mbbs_llrm.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>18</td>
                                <td>30-07-2024</td>
                                <td>B.Tech (Chemical Engineering) Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/b.tech_ce.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>19</td>
                                <td>30-07-2024</td>
                                <td>M.A. (Journalism & Mass Communication) Regular Course year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_jmc.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>20</td>
                                <td>30-07-2024</td>
                                <td>B.Sc. (Computer Science) Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/bsc_cs.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>21</td>
                                <td>30-07-2024</td>
                                <td>M.LIB Regular Course year 2024 </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/m.lib.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>22</td>
                                <td>30-07-2024</td>
                                <td>M.B.A. Campus Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/mba_campus.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>23</td>
                                <td>30-07-2024</td>
                                <td>M.Sc. Home Science (TEX) Regular Course year 2024 </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/msc_hs_tex.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>24</td>
                                <td>30-07-2024</td>
                                <td>M.Sc. (Computer Science) Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/msc_cs.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>25</td>
                                <td>30-07-2024</td>
                                <td>M.B.B.S.- II Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/mbbs-2nd.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>26</td>
                                <td>30-07-2024</td>
                                <td>M.Sc. Bio-Informatics Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/msc_bio_informatics.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>27</td>
                                <td>30-07-2024</td>
                                <td>B.O.T. Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/bot.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>28</td>
                                <td>30-07-2024</td>
                                <td>BCA Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/bca.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>29</td>
                                <td>01-08-2024</td>
                                <td>B.B.A. Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/BBA.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>30</td>
                                <td>06-08-2024</td>
                                <td> B.Com Honours Regular course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bcom_hons.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>31</td>
                                <td>06-08-2024</td>
                                <td> B.Voc Yogic Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bvoc_yogic.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>32</td>
                                <td>06-08-2024</td>
                                <td>B.Sc. Microbiology - III Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bsc_microbiology_3.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>33</td>
                                <td>06-08-2024</td>
                                <td>Revised B.Tech Mechanical Engineering Regular Course Year 2024
                                </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/btech%20mechanical%20engineering.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>34</td>
                                <td>06-08-2024</td>
                                <td>B.Sc. Biotechnology Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bsc%20biotechnology.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>35</td>
                                <td>06-08-2024</td>
                                <td>M.Sc. Bio-chemistry Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc%20bio-chem.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>36</td>
                                <td>06-08-2024</td>
                                <td>M.B.B.S-III Prof. Part-I Regualr Course Year 2024 </td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/mbbs%203%20prof%20part%201.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>37</td>
                                <td>06-08-2024</td>
                                <td>Revised M.Sc. Microbiology Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc%20microbiology.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>38</td>
                                <td>06-08-2024</td>
                                <td>B.Voc in Tour & Tourism Management Regular Course year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bvoc%20(2).pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>39</td>
                                <td>06-08-2024</td>
                                <td>B.Voc in (Mediacl Lab & Molecular) Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bvoc.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>40</td>
                                <td>06-08-2024</td>
                                <td>B.P.E.S Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bpes.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>41</td>
                                <td>06-08-2024</td>
                                <td>B.D.S Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bds.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>42</td>
                                <td>08-08-2024</td>
                                <td>B.F.A.-IV Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bfa-4.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>43</td>
                                <td>08-08-2024</td>
                                <td>Revised M.P.Ed Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/mped.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>44</td>
                                <td>08-08-2024</td>
                                <td>M.P.E.S. Regular Course Year 2024</td>
                                <td>
                                    <a className="btn btn-primary btn-download" target="_blank"
                                        rel='noreferrer'
                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/mpes.pdf">Download
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>45</td>
                                <td>11-08-2024</td>
                                <td>B.Lib Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/blib-2.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>46</td>
                                <td>11-08-2024</td>
                                <td>M.Sc. Bio-Tech Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-biotech.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>47</td>
                                <td>11-08-2024</td>
                                <td>M.Sc. Home Science Food & Nutrition Regular Course Year 2024
                                </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-homesc-food.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>48</td>
                                <td>11-08-2024</td>
                                <td>B.P.Ed Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bped.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>49</td>
                                <td>12-08-2024</td>
                                <td> B.Sc. Home Science Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bsc-home-sc.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>50</td>
                                <td>12-08-2024</td>
                                <td> M.B.A. (HA) Campus Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/mba-he-campus.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>51</td>
                                <td>13-08-2024</td>
                                <td>M.Sc. Home Science (Human Development) Regular Course Year 2024
                                </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-home-sc.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>52</td>
                                <td>14-08-2024</td>
                                <td>Revised M.Tech Electronics & Communication Campus Regular Course
                                    Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/m.tech-electronics-comm-rev.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>53</td>
                                <td>14-08-2024</td>
                                <td> Revised M.Tech Computer Science Campus Regular Course Year 2024
                                </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/m.tech-comp-sc-rev.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>54</td>
                                <td>20-08-2024</td>
                                <td> B.U.M.S IVth Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bums-4th.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>55</td>
                                <td>20-08-2024</td>
                                <td> B.A.M.S IVth Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bams-4th.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>56</td>
                                <td>23-08-2024</td>
                                <td> B.Sc. Nursing Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bsc-nursing.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>57</td>
                                <td>24-08-2024</td>
                                <td>B.A.M.S-4 Regular Course Year 2022</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bamms-4.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr> */}

                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEvent3(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Event 4 Modal */}
            <Modal show={showEvent4} onHide={() => setShowEvent4(false)} size="lg" className='modalMain'>
                <Modal.Header closeButton>
                    <Modal.Title>Confidential Merit List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Updated Date</th>
                                <th>Title</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>01</td>
                                <td>16-06-2026</td>
                                <td>B.El.Ed. Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/001%20(30).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>02</td>
                                <td>17-06-2026</td>
                                <td>B.A.B.Ed. Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/003%20(83).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>03</td>
                                <td>18-06-2026</td>
                                <td>M.A. HINDI Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/003%20(5).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>04</td>
                                <td>19-06-2026</td>
                                <td>M.A. URDU Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/002%20-%202026-06-19T182152.139.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>05</td>
                                <td>19-06-2026</td>
                                <td>M.Ed. Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/003%20(84).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr> */}
                            <tr>
                                <td>05</td>
                                <td>23-06-2026</td>
                                <td>M.A. EDUCATION Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/002%20-%202026-06-23T143623.640.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>06</td>
                                <td>23-06-2026</td>
                                <td>M.A. SANSKRIT Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/003%20conf.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>07</td>
                                <td>23-06-2026</td>
                                <td>M.A. MUSIC Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/004%20conf.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>08</td>
                                <td>23-06-2026</td>
                                <td>M.A. PHILOSOPHY Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/005%20conf.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>09</td>
                                <td>23-06-2026</td>
                                <td>M.A. PSYCHOLOGY Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/006%20conf.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>23-06-2026</td>
                                <td>M.A. DRAWING & PAINTING Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/007%20conf.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>23-06-2026</td>
                                <td>M.A. DEFENCE STUDIES Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/008.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>24-06-2026</td>
                                <td>B.SC. PHYSICAL EDUCATION & SPORTS Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/018.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>24-06-2026</td>
                                <td>M.Sc. BOTANY Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/019.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>24-06-2026</td>
                                <td>M.Sc. ZOOLOGY Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/020.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>24-06-2026</td>
                                <td>M.Sc. (AG) AGRICULTURAL EXT. Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/021.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>24-06-2026</td>
                                <td>M.Sc. (AG) HORTICULTURE Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/022.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>17</td>
                                <td>24-06-2026</td>
                                <td>M.Sc. (AG) AGR. CHEM. & SOIL SCI. Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/023.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>18</td>
                                <td>24-06-2026</td>
                                <td>M.Sc. (AG) AGRICULTURAL ECO. Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/024.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>19</td>
                                <td>24-06-2026</td>
                                <td>M.Sc. (AG) DAIRY SCI. & TECH. Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/025.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>20</td>
                                <td>24-06-2026</td>
                                <td>M.Sc. (AG) PLANT PATHOLOGY Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/026.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>21</td>
                                <td>25-06-2026</td>
                                <td>M.Sc. (AG) GEN. & PLANT BREEDING Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/005%20conf(55).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>22</td>
                                <td>25-06-2026</td>
                                <td>M.Sc. (AG) AGRONOMY Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/006%20conf%20(43).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>23</td>
                                <td>25-06-2026</td>
                                <td>M.A. ECONOMICS Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/010%20conf(13).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>24</td>
                                <td>25-06-2026</td>
                                <td>M.A. SOCIOLOGY Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/011%20conf%20(12).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>25</td>
                                <td>29-06-2026</td>
                                <td>B.Com. LL.B. Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/009%20(16)%20conf.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>26</td>
                                <td>29-06-2026</td>
                                <td>M.A. HOME SCIENCE Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/016%20(3)%20conf.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>27</td>
                                <td>30-06-2026</td>
                                <td>M.Sc. PHYSICS Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/conf%20002.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>28</td>
                                <td>30-06-2026</td>
                                <td>M.Sc. CHEMISTRY Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/conf%20003%20(84).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>29</td>
                                <td>02-07-2026</td>
                                <td>M.A. MATHEMATICS Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/001%20-%202026-07-02T175356.711.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>30</td>
                                <td>03-07-2026</td>
                                <td>B.Sc. (Ag) HONS.  Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/conf%20004%20(65).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>31</td>
                                <td>03-07-2026</td>
                                <td>B.A.LL.B. Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/confidential%20005%20(55).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>32</td>
                                <td>03-07-2026</td>
                                <td>LL.B. Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/confidential%20006%20(43).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>33</td>
                                <td>03-07-2026</td>
                                <td>LL.M. Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/007%20(31).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>34</td>
                                <td>04-07-2026</td>
                                <td>B.COM. (N.E.P.) Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/003%20(8)%20conf.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>35</td>
                                <td>04-07-2026</td>
                                <td>B.A. (N.E.P.) Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/002%20-%20conf.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>36</td>
                                <td>04-07-2026</td>
                                <td>B.Sc. (N.E.P.) Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/001%20-%20conf.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>37</td>
                                <td>05-07-2026</td>
                                <td>B.Ed. Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/001%20-%20confidential.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>38</td>
                                <td>10-07-2026</td>
                                <td>M.A. ENGLISH Regular Course 2026</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/002%20-%202026-07-10T171840.352conf.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>01</td>
                                <td>30-07-2025</td>
                                <td>M.A. Psychology Regular Course 2025</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/012%20(6).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>02</td>
                                <td>30-07-2025</td>
                                <td>M.A. Music Regular  Course 2025</td>
                                <td>
                                    <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/07/013%20(3).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>03</td>
                                <td>06-08-2025</td>
                                <td>M.A. Physical Education Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/professional_01.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>04</td>
                                <td>12-08-2025</td>
                                <td>B.A.LL.B Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/001%20(79).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>05</td>
                                <td>12-08-2025</td>
                                <td>M.A. Visual Art Draw & Paint Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/004%20(41)%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>06</td>
                                <td>12-08-2025</td>
                                <td>B.Sc. Agriculture Honours Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/005%20(38)%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>07</td>
                                <td>12-08-2025</td>
                                <td>B.A.B.Ed. Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/027.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>08</td>
                                <td>12-08-2025</td>
                                <td>M.A. English Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/035%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>09</td>
                                <td>12-08-2025</td>
                                <td>M.A. Hindi Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/036.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>12-08-2025</td>
                                <td>M.A. Sociology Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/037.pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>13-08-2025</td>
                                <td>LL.M Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/007%20(19).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>13-08-2025</td>
                                <td>M.Sc. Chemistry Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/008%20(19).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>13-08-2025</td>
                                <td>M.Sc. Statistics Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/009%20(8).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>25-08-2025</td>
                                <td>Revised M.Sc. Zoology Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/008%20(24).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>25-08-2025</td>
                                <td>Revised M.Sc. Physics Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/007%20(23).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>25-08-2025</td>
                                <td>Revised M.Sc. Mathematics Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/006%20(34).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>17</td>
                                <td>25-08-2025</td>
                                <td>Revised M.Sc. Botany Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/009%20(11).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>18</td>
                                <td>13-08-2025</td>
                                <td>B.Sc. Physical Education & Sports Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/014%20(3).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>19</td>
                                <td>13-08-2025</td>
                                <td>M.A. Defence Studies Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/015%20(2).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>20</td>
                                <td>13-08-2025</td>
                                <td>M.A. Urdu Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/016%20(2).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>21</td>
                                <td>13-08-2025</td>
                                <td>M.A. Education Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/001%20(80).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>22</td>
                                <td>13-08-2025</td>
                                <td>M.A. Economics Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/018%20(1)%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>23</td>
                                <td>13-08-2025</td>
                                <td>M.A. Geography Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/019%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>24</td>
                                <td>13-08-2025</td>
                                <td>M.A. Political Science Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/020%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>25</td>
                                <td>14-08-2025</td>
                                <td>B.A. Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/006%20(31).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>26</td>
                                <td>14-08-2025</td>
                                <td>B.Com. Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/009%20(9).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>27</td>
                                <td>14-08-2025</td>
                                <td>M.Com. Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/010%20(11).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>28</td>
                                <td>14-08-2025</td>
                                <td>B.Com.LL.B Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/011%20(9).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>29</td>
                                <td>14-08-2025</td>
                                <td>M.A. Philosophy Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/012%20(9).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>30</td>
                                <td>14-08-2025</td>
                                <td>M.A. Mathematics Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/013%20(6).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>31</td>
                                <td>14-08-2025</td>
                                <td>M.A. Sanskrit Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/014%20(4).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>32</td>
                                <td>20-08-2025</td>
                                <td>B.EI.Ed. Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/001%20(82).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>33</td>
                                <td>20-08-2025</td>
                                <td>M.A. History Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/001%20(84).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>34</td>
                                <td>20-08-2025</td>
                                <td>M.Ed. Regular/Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/002%20(79)%20(1).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>35</td>
                                <td>25-08-2025</td>
                                <td>M.A. Home Science Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/005%20(42).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>36</td>
                                <td>25-08-2025</td>
                                <td>M.Sc. Ag. Horticulture Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/010%20(12).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>37</td>
                                <td>25-08-2025</td>
                                <td>M.Sc. Ag. Ext. Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/011%20(10).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>38</td>
                                <td>25-08-2025</td>
                                <td>M.Sc. Ag. Agronomy Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/012%20(10).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>39</td>
                                <td>25-08-2025</td>
                                <td>M.Sc. Ag. Agriculture Eco. Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/013%20(7).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>40</td>
                                <td>25-08-2025</td>
                                <td>M.Sc. Ag. Chem. & Soil Sci. Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/014%20(5).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>41</td>
                                <td>25-08-2025</td>
                                <td>M.Sc. Ag. Dairy Sci. & Tech. Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/015%20(3).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>42</td>
                                <td>25-08-2025</td>
                                <td>L.L.B. Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/001%20(86).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>43</td>
                                <td>28-08-2025</td>
                                <td>B.Sc. NEP Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/001%20(88).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>44</td>
                                <td>28-08-2025</td>
                                <td>B.Com. NEP Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/003%20(64).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>45</td>
                                <td>29-08-2025</td>
                                <td>B.Ed. Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/confidential_dept/001%20(89).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>46</td>
                                <td>01-09-2025</td>
                                <td>B.A. NEP Regular Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/confidential_dept/003%20(65).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>47</td>
                                <td>01-09-2025</td>
                                <td>M.A. Sanskrit Private Course 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/confidential_dept/004%20(47).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>48</td>
                                <td>04-09-2025</td>
                                <td>M.Sc. Physics Regular Course 2025 (only boys)</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/001%20(91).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>49</td>
                                <td>04-09-2025</td>
                                <td>B.Sc. Maths NEP Regular Course 2025 (only girls)</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/005%20(45).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>50</td>
                                <td>06-09-2025</td>
                                <td>M.Sc. Ag. Plant Pathology Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/confidential_dept/002%20(86).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>51</td>
                                <td>06-09-2025</td>
                                <td>M.Sc. Ag. Gen. & Plant Breeding Regular Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/confidential_dept/003%20(67).pdf">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>52</td>
                                <td>08-09-2025</td>
                                <td>B.A. Hindi NEP Regular/Private Course year 2025</td>
                                <td>
                                    <a class="btn btn-primary btn-download" target="_blank" rel="noreferrer" href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/003%20(66)%20(1).pdf">Download</a>
                                </td>
                            </tr> */}
                            {/* <tr>
                                <td>03</td>
                                <td>31-07-2024</td>
                                <td>M.A. Defence Studies Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_def_stu.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>04</td>
                                <td>31-07-2024</td>
                                <td>M.A. Economics Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_eco.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>05</td>
                                <td>31-07-2024</td>
                                <td>M.A. Education Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_edu.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>06</td>
                                <td>31-07-2024</td>
                                <td>M.A. English Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_eng.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>07</td>
                                <td>31-07-2024</td>
                                <td>M.A. Hindi Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_hindi.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>08</td>
                                <td>31-07-2024</td>
                                <td>M.A. Philosophy Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_phil.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>09</td>
                                <td>31-07-2024</td>
                                <td>M.A. Physical Education Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_phy_edu.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>31-07-2024</td>
                                <td>M.A. Political Science Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_pol_sc.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>31-07-2024</td>
                                <td>M.A. Psychology Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_psy.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>31-07-2024</td>
                                <td>M.A. Sanskrit Regular, Private course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_sanskrit.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>31-07-2024</td>
                                <td>M.A. Urdu Regular, Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/ma_urdu.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>31-07-2024</td>
                                <td>M.Sc. (Ag.) EXT. Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/msc_ag_ext.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>31-07-2024</td>
                                <td>M.Sc. Ag. Genetics & Plant Breeding Regular Course year 2024
                                </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/msc_ag_gen_plant.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>31-07-2024</td>
                                <td>M.A. Mathematics Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-math.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>17</td>
                                <td>01-08-2024</td>
                                <td>B.A. LL.B Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/BALLB.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>18</td>
                                <td>01-08-2024</td>
                                <td>B.Com LL.B Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/BCOMLLB.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>19</td>
                                <td>03-08-2024</td>
                                <td>M.Sc. (AG) Agronomy Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/001%20(27).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>20</td>
                                <td>03-08-2024</td>
                                <td>M.Sc. (AG) AG-ECO Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/002%20(30).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>21</td>
                                <td>03-08-2024</td>
                                <td>M.Sc. (AG) Dairy SC & TECH Regular Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/003%20(19).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>22</td>
                                <td>03-08-2024</td>
                                <td>M..A. History Regular & Private Course year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/008%20(4).pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>23</td>
                                <td>07-08-2024</td>
                                <td>M.A. Music Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma_music.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>24</td>
                                <td>07-08-2024</td>
                                <td>M.A. Sociology Regular & Professional Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma_sociology.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>25</td>
                                <td>08-08-2024</td>
                                <td> M.Com Regular & Private Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/mcom.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>26</td>
                                <td>08-08-2024</td>
                                <td>M.Sc. Botany Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-bot.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>27</td>
                                <td>08-08-2024</td>
                                <td> M.S.c Statistic Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-stat.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>28</td>
                                <td>08-08-2024</td>
                                <td> M.Sc. Zoology Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-zoo.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>29</td>
                                <td>08-08-2024</td>
                                <td>M.Sc. Physics Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-phy.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>30</td>
                                <td>10-08-2024</td>
                                <td>M.A. Home Science Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-home-sc.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>31</td>
                                <td>11-08-2024</td>
                                <td>L.L.B Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/llb.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>32</td>
                                <td>11-08-2024</td>
                                <td>M.A. Visual Arts (D & P) Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-visual-arts.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>33</td>
                                <td>11-08-2024</td>
                                <td>M.A. Geography Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-geo.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>34</td>
                                <td>11-08-2024</td>
                                <td>M.Sc. AG Horticulture Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-hoti.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>35</td>
                                <td>12-08-2024</td>
                                <td> LL.M. Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/llm-regular.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>36</td>
                                <td>12-08-2024</td>
                                <td> Revised M.Sc. Mathematics Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/rev-msc-maths.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>37</td>
                                <td>12-08-2024</td>
                                <td> M.Sc. Chemistry Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-chem-2.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>38</td>
                                <td>12-08-2024</td>
                                <td> M.Sc. (Ag) CHE & Soil Sc. Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/msc-ag-che-soli-sc.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>39</td>
                                <td>13-08-2024</td>
                                <td>M.Ed Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/med-reg-course.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>40</td>
                                <td>13-08-2024</td>
                                <td> B.A.B.ED Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ba-bed.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>41</td>
                                <td>21-08-2024</td>
                                <td>Revised B.EL.ED Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/belded-rev.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>42</td>
                                <td>22-08-2024</td>
                                <td>M.A. Sanskrit Private Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ma-sanskrit-2.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>43</td>
                                <td>23-08-2024</td>
                                <td>B.A. Private Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ba-pvt.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>44</td>
                                <td>24-08-2024</td>
                                <td>B.Com Private Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bcom.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>45</td>
                                <td>24-08-2024</td>
                                <td>B.Com N.E.P Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bcom-nep.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>46</td>
                                <td>27-08-2024</td>
                                <td>Revised B.A. N.E.P Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ba-nep-rev.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>47</td>
                                <td>28-08-2024</td>
                                <td>B.Sc. (N.E.P) Mathematics Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/math-nep.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>48</td>
                                <td>28-08-2024</td>
                                <td> B.A. (N.E.P) Hindi Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ba-nep-hindi.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>49</td>
                                <td>28-08-2024</td>
                                <td> B.A. Hindi Private Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/ba-nep-hindi-pvt.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>50</td>
                                <td>28-08-2024</td>
                                <td> B.Sc. N.E.P Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/bsc-nep-reg.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>
                            <tr>
                                <td>51</td>
                                <td>29-08-2024</td>
                                <td> Revised B.Ed Regular Course Year 2024</td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/b.ed-reg-rev.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr>

                            <tr>
                                <td>52</td>
                                <td>29-08-2024</td>
                                <td>Revised M.Sc. Mathematics Regular Course Year 2024 </td>
                                <td>
                                    <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/08/maths-rev-msc.pdf"
                                        target="_blank"
                                        rel='noreferrer'
                                        className="btn btn-primary btn-download">Download</a>
                                </td>
                            </tr> */}


                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEvent4(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default Main;
